import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  createAssessmentAPIEndpoint,
  EndPoints,
} from "../../../services/AssessmentServices";

function HomeworkPage() {
  const { id } = useParams();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submissionId, setSubmissionId] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [showValidation, setShowValidation] = useState(false);
  const answersRef = useRef([]);
  const submissionIdRef = useRef(null);

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  // ====== START homework ======
  const startHomework = () => {
    createAssessmentAPIEndpoint(EndPoints.startAssessment(id))
      .postWithToken()
      .then((res) => {
        setSubmissionId(res.data.id);
        submissionIdRef.current = res.data.id;
        fetchQuestions(res.data.id);
      })
      .catch((error) => {
        console.error("Error starting homework:", error);
        setLoading(false);
      });
  };
  const fetchQuestions = (id) => {
    createAssessmentAPIEndpoint(EndPoints.getQuestions(id))
      .fetch()
      .then((res) => {
        setQuestions(res.data.questions || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching questions:", error);
        setLoading(false);
      });
  };
  // ====== SUBMIT ======

  const handleSubmitClick = () => {
    setShowValidation(true);
    const unanswered = questions.filter(
      (q) => !answers.some((a) => a.questionId === q.questionId),
    );
    if (unanswered.length > 0) {
      enqueueSnackbar("Please answer all questions before submitting.", {
        variant: "warning",
      });
      return;
    }
    else
      handleSubmit();
  };
  const handleSubmit = (providedAnswers) => {
    const finalAnswers = providedAnswers || answersRef.current;
    const currentSubmissionId = submissionId || submissionIdRef.current;

    createAssessmentAPIEndpoint(EndPoints.submitAnswers)
      .postWithToken({ assessmentId: id, answers: finalAnswers })
      .then(() => {
        enqueueSnackbar("Submitted successfully!", { variant: "success" });
        navigate(`/assessment/result/${currentSubmissionId}`);
      })
      .catch(() => {
        enqueueSnackbar("Submission failed", { variant: "error" });
      });
  };

  // ====== ANSWERS ======
  const handleAnswer = (questionId, answer) => {
    const updatedAnswers = [
      ...answers.filter((ans) => ans.questionId !== questionId),
      { questionId, selectedOptionIndex: answer },
    ];
    setAnswers(updatedAnswers);
    answersRef.current = updatedAnswers;
  };

  useEffect(() => {
    setLoading(true);
    startHomework();
  }, []);

  return (
    <>
      {loading ? (
        <div className="section loading-message">Loading...</div>
      ) : questions.length === 0 ? (
        <div className="section no-questions-message">
          No questions found for this homework.
        </div>
      ) : (
        <div className="homework-page section " translate="no">
          <div className="container">
            {questions.map((question, index) => {
              const isAnswered = answers.some(
                (ans) => ans.questionId === question.questionId,
              );
              const showError = showValidation && !isAnswered;
              return (
                <div
                  key={index}
                  className={`question-wrapper ${showError ? "validation-error" : ""}`}
                >
                  <p className={"question-text"}>{question.text}</p>
                  <div className="options-container">
                    {question.options.map((opt, optIndex) => {
                      const existingAnswer = answers.find(
                        (ans) => ans.questionId === question.questionId,
                      );
                      const isChecked = existingAnswer
                        ? existingAnswer.selectedOptionIndex === optIndex
                        : false;
                      return (
                        <label
                          key={optIndex}
                          className={`option-label ${isChecked ? "selected" : ""}`}
                        >
                          <input
                            type="radio"
                            className="option-input"
                            name={`q-${question.questionId}`}
                            value={opt}
                            checked={isChecked}
                            onChange={() =>
                              handleAnswer(question.questionId, optIndex)
                            }
                          />
                          <span className="option-text">{opt}</span>
                        </label>
                      );
                    })}
                  </div>
                </div>
              );
            })}
            <button onClick={handleSubmitClick} className="submit-btn">
              Submit homework
            </button>
          </div>
        </div>
      )}
    </>
  );
}
export default HomeworkPage;
